/* eslint-disable @typescript-eslint/no-var-requires */
export const availableCards = {
    'physical.black.limited': {
        img: require(`./base/assets/images/availableCards/physicalBlack.png`),
        label: 'keys:creditCards.physical.black.standard.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#171717',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'physical.black2.limited': {
        img: require(`./base/assets/images/availableCards/physicalBlack.png`),
        label: 'keys:creditCards.physical.black.standard.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#171717',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'physical.black.limitless': {
        img: require(`./base/assets/images/availableCards/physicalBlack.png`),
        label: 'keys:creditCards.physical.black.premium.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#171717',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'physical.black2.limitless': {
        img: require(`./base/assets/images/availableCards/physicalBlack.png`),
        label: 'keys:creditCards.physical.black.premium.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#171717',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'physical.hills.limited': {
        img: require(`./base/assets/images/availableCards/physicalHills.png`),
        label: 'keys:creditCards.physical.hills.standard.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: 'linear-gradient(180deg, #E8E8E8 0%, #F2F2F2 100%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'physical.hills2.limited': {
        img: require(`./base/assets/images/availableCards/physicalHills.png`),
        label: 'keys:creditCards.physical.hills.standard.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: 'linear-gradient(180deg, #E8E8E8 0%, #F2F2F2 100%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'physical.hills.limitless': {
        img: require(`./base/assets/images/availableCards/physicalHills.png`),
        label: 'keys:creditCards.physical.hills.premium.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: 'linear-gradient(180deg, #E8E8E8 0%, #F2F2F2 100%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'physical.hills2.limitless': {
        img: require(`./base/assets/images/availableCards/physicalHills.png`),
        label: 'keys:creditCards.physical.hills.premium.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: 'linear-gradient(180deg, #E8E8E8 0%, #F2F2F2 100%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'physical.gti.standard': {
        img: require(`./base/assets/images/availableCards/physicalStandardGTI.png`),
        label: 'keys:creditCards.physical.standard.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: 'linear-gradient(90deg, #0E1221 0%, #0D132F 100.01%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'physical.gti.blue': {
        img: require(`./base/assets/images/availableCards/physicalStandardGTI.png`),
        label: 'keys:creditCards.physical.standard.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: 'linear-gradient(90deg, #0E1221 0%, #0D132F 100.01%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'physical.gti.gold': {
        img: require(`./base/assets/images/availableCards/physicalGoldGTI.png`),
        label: 'keys:creditCards.physical.gold.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: 'linear-gradient(65.75deg, #FAEB74 2.98%, #DB8927 88.06%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'physical.gti.platinum': {
        img: require(`./base/assets/images/availableCards/physicalPlatinumGTI.png`),
        label: 'keys:creditCards.physical.platinum.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#141845',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'physical.pheonix.white': {
        img: require(`./base/assets/images/availableCards/physicalPhoenixWhite.png`),
        label: 'keys:creditCards.virtual.default.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: '#F3F4F4',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'physical.pheonix.black': {
        img: require(`./base/assets/images/availableCards/physicalPheonixBlack.png`),
        label: 'keys:creditCards.virtual.default.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#070707',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'physical.mountains': {
        img: require(`./base/assets/images/availableCards/physicalHills.png`),
        label: 'keys:creditCards.physical.hills.standard.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: 'linear-gradient(180deg, #E8E8E8 0%, #F2F2F2 100%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'physical.h.black': {
        img: require(`./base/assets/images/availableCards/physicalBlack.png`),
        label: 'keys:creditCards.physical.black.standard.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#171717',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'virtual.default': {
        img: require(`./base/assets/images/availableCards/virtualDefault.png`),
        label: 'keys:creditCards.virtual.default.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: '#F3F4F4',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'virtual.gti': {
        img: require(`./base/assets/images/availableCards/virtualGTI.png`),
        label: 'keys:creditCards.virtual.default.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: 'linear-gradient(90deg, #151948 0.01%, #121642 100.02%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'virtual.pheonix': {
        img: require(`./base/assets/images/availableCards/virtualPhoenix.png`),
        label: 'keys:creditCards.virtual.pheonix.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: '#F3F4F4',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'virtual.foxpay': {
        img: require(`./base/assets/images/availableCards/virtualFoxpay.png`),
        label: 'keys:creditCards.virtual.foxpay.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#070707',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
    'virtual.mountains': {
        img: require(`./base/assets/images/availableCards/virtualHills.png`),
        label: 'keys:creditCards.virtual.default.label',
        color: {
            back: {
                mainText: '#222222',
                infoText: '#222222',
                background: 'linear-gradient(180deg, #E8E8E8 0%, #F2F2F2 100%)',
                magneticStrip: '#222222',
            },
            front: {
                text: '#222222',
            },
            buttons: {
                backgroundDefault: '#222222',
                backgroundDisabled: '#4F4F4F',
                backgroundHover: '#474747',
                borderDefault: 'rgba(34,34,34,0.35)',
                borderDisabled: 'rgba(79,79,79,0.35)',
            },
        },
    },
    'virtual.h.black': {
        img: require(`./base/assets/images/availableCards/virtualBlack.png`),
        label: 'keys:creditCards.virtual.default.label',
        color: {
            back: {
                mainText: '#FFFFFF',
                infoText: '#999999',
                background: '#171717',
                magneticStrip: '#222222',
            },
            front: {
                text: '#FFFFFF',
            },
            buttons: {
                backgroundDefault: '#878E9F',
                backgroundDisabled: '#3F3339',
                backgroundHover: '#A5AAB6',
                borderDefault: 'rgba(135,142,159,0.35)',
                borderDisabled: '#261315',
            },
        },
    },
}
